import { useSourceAccounts } from './useSourceAccounts';

export const useCloudProviders = () => {
  const { sourceAccounts } = useSourceAccounts();
  const providers = Array.from(
    new Set((sourceAccounts || []).map((x) => x.cloudProvider))
  );
  return providers;
};
